export { TabbedPersonalizedProductCarousel } from './tabbed-carousel';
